import dayjs from 'dayjs';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import { usePlaymakersOptions } from '../../store';

import ErrorBoundary from '@shared/ErrorBoundary';

import * as styles from './styles.module.scss';

const Footer = () => {
  const {
    options: { acceptedLanguages },
  } = usePlaymakersOptions();
  const { i18n, t } = useTranslation();
  const navigate = useNavigate();

  const language = i18n.language;

  const siteLang = ['fr', 'de', 'it', 'ru', 'es', 'pt'].includes(language) ? language : 'en';
  const baseUrl = `https://${siteLang}.uefa.com`;

  const handleLanguageChange = (locale) => () => {
    navigate(`/${locale}/`);
  };

  return (
    <ErrorBoundary>
      <div className={styles.footer}>
        <div className={styles.footerLogo}>
          <img
            alt='Playmakers'
            className='pflazyload'
            title='Playmakers'
            data-srcset={`${window.imgBaseUrl}/imgml/uefacom/playmakers/uefa` + '.svg'}
          />

          <img
            alt='Playmakers'
            className='pflazyload'
            title='Playmakers'
            data-srcset={`${window.imgBaseUrl}/imgml/uefacom/playmakers/disney` + '.svg'}
          />

          <img
            alt='Playmakers'
            className='pflazyload'
            title='Playmakers'
            data-srcset={`${window.imgBaseUrl}/imgml/uefacom/playmakers/fa` + '.svg'}
          />
        </div>
        <div className={styles.footerLinks}>
          <p>{t('check_out_more')}</p>
          <ul>
            <li>
              <a title='UEFA.com' href={baseUrl}>
                UEFA.com
              </a>
            </li>
            <li>
              <a title={t('nav_women')} href={`${baseUrl}/development/womens-football/`}>
                {t('nav_women')}
              </a>
            </li>
            <li>
              <a title='#weplaystrong' href='https://www.weplaystrong.com/#/trending'>
                #weplaystrong
              </a>
            </li>
          </ul>

          <div>
            <p>{t('language')}</p>
          </div>
          <ul>
            {acceptedLanguages.map((l) => (
              <li key={`lang_${l}`}>
                {language !== l ? (
                  <button
                    type='button'
                    title={t(`lang_${l}`)}
                    className={styles.footerLang}
                    onClick={handleLanguageChange(l)}
                  >
                    {t(`lang_${l}`)}
                  </button>
                ) : (
                  <strong>{t(`lang_${l}`)}</strong>
                )}
              </li>
            ))}
          </ul>
        </div>
        <div className={styles.footerSep} />
        <div className={styles.footerCopyright}>&copy; 1998-{dayjs().year()} UEFA. All rights reserved</div>
        <div className={styles.footerPrivacy}>
          <span>
            <a title={t('nav_terms_and_conditions')} href={`${baseUrl}/termsconditions/`}>
              {t('nav_terms_and_conditions')}
            </a>
          </span>
          <span>
            <a title={t('privacy')} href={`${baseUrl}/privacypolicy/`}>
              {t('privacy')}
            </a>
          </span>
          <span>
            <a title={t('cookie_policy')} href={`${baseUrl}/cookiepolicy/`}>
              {t('cookie_policy')}
            </a>
          </span>
        </div>
      </div>
    </ErrorBoundary>
  );
};

export default memo(Footer);
